/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeDefinitionBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AttributeDefinitionBase.fixupPrototype; }

    static newInstance(model: Partial<AttributeDefinitionBase>): AttributeDefinitionBase {
        let obj = Object.assign(new AttributeDefinitionBase(), model);
        AttributeDefinitionBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeDefinitionBase>): AttributeDefinitionBase {
        if (!model) return null;
        return AttributeDefinitionBase.newInstance(<AttributeDefinitionBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeDefinitionBase) {
        if (!obj) return;

        models.AttributeDefinitionBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeDefinitionBase): boolean {
        switch (obj.__type)
        {
            case "AttributeDefinitionForBoolean":
                Object.setPrototypeOf(obj, models.AttributeDefinitionForBoolean.prototype);
                break;
            case "AttributeDefinitionForDateTime":
                Object.setPrototypeOf(obj, models.AttributeDefinitionForDateTime.prototype);
                break;
            case "AttributeDefinitionForNumber":
                Object.setPrototypeOf(obj, models.AttributeDefinitionForNumber.prototype);
                break;
            case "AttributeDefinitionForString":
                Object.setPrototypeOf(obj, models.AttributeDefinitionForString.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AttributeDefinitionBase)[] {
        return [
            models.AttributeDefinitionForBoolean,
            models.AttributeDefinitionForDateTime,
            models.AttributeDefinitionForNumber,
            models.AttributeDefinitionForString,
        ];
    }

    fixupFields() {
    }

    /**
     * Name of the Attribute
     */
    name: string;

    /**
     * Is the dimensions attribute mandatory
     */
    mandatory: boolean;

}
